import React, { useContext } from 'react'
// import ThemeContext from "../../context/themeContext"

function Signature({
  size = 24,
  title = 'Danniel Hansel',
}) {

  // const { theme, setTheme } = useContext(ThemeContext)
  return (
		<svg 
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
			// width="227.000000pt" height="92.000000pt" 
			viewBox="0 0 227.000000 92.000000"
			preserveAspectRatio="xMidYMid meet"
			className={`w-${size} h-${size} stroke-current `}>
      <title>{title}</title>
			<g 
				stroke="currentColor"
				strokeWidth={1.5}
				strokeLinecap="round"
				strokeLinejoin="round"
				transform="translate(0.000000,92.000000) scale(0.100000,-0.100000)"
				fill="currentColor"
			>
				<path 
					stroke="currentColor"
					strokeWidth={1.5}
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M425 903 c-51 -6 -178 -34 -230 -50 -82 -25 -185 -75 -185 -89 0 -18
					3 -18 85 11 39 14 73 25 77 25 4 0 7 -48 5 -107 -2 -93 25 -465 39 -531 5 -23
					34 -31 34 -9 0 6 -6 70 -14 142 -8 72 -17 218 -20 326 l-5 196 80 26 c68 23
					107 29 282 39 198 11 203 11 277 -12 89 -27 168 -74 181 -107 15 -41 10 -96
					-15 -148 -18 -38 -46 -69 -120 -130 -53 -44 -110 -86 -126 -95 -16 -8 -71 -40
					-122 -71 -51 -30 -205 -110 -341 -177 -141 -69 -246 -126 -242 -132 10 -15 92
					-12 217 9 62 11 217 32 343 47 218 25 255 27 710 28 264 1 584 -3 710 -7 127
					-5 228 -7 225 -4 -22 21 -1203 41 -1368 23 -26 -3 -105 -8 -177 -11 -71 -3
					-168 -11 -215 -16 -132 -16 -345 -37 -348 -35 -1 2 69 36 155 76 443 207 690
					377 736 505 21 60 22 116 3 153 -20 39 -109 88 -200 112 -65 16 -108 20 -240
					19 -89 -1 -174 -4 -191 -6z"/>
				<path 
					stroke="currentColor"
					strokeWidth={1.5}
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M1531 853 c-45 -98 -44 -243 3 -403 15 -54 19 -80 11 -80 -6 0 -26
					-16 -45 -35 -47 -49 -88 -48 -69 2 6 18 6 30 -2 40 -10 12 -17 9 -45 -19 -17
					-18 -42 -35 -55 -38 -39 -9 -35 -30 7 -30 21 0 45 -7 54 -15 9 -8 30 -18 47
					-21 27 -5 37 -1 69 30 37 36 67 46 79 26 12 -19 22 -10 39 33 22 57 23 246 2
					347 -36 171 -67 225 -95 163z m55 -120 c16 -65 19 -332 4 -347 -12 -12 -37 77
					-51 181 -9 65 -8 103 1 165 14 90 25 91 46 1z"/>
				<path 
					stroke="currentColor"
					strokeWidth={1.5}
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M1250 535 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0
					-10 -7 -10 -15z"/>
					<path d="M1117 383 c-10 -18 -5 -168 6 -175 18 -11 37 11 37 43 0 24 4 29 23
					29 12 0 33 8 46 17 14 9 21 12 18 6 -9 -14 19 -37 33 -28 13 8 13 41 0 66 -14
					24 -41 24 -73 -1 -27 -21 -38 -16 -51 28 -7 21 -30 30 -39 15z"/>
				<path 
					stroke="currentColor"
					strokeWidth={1.5}
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M945 305 c-14 -50 -18 -54 -35 -45 -11 6 -20 15 -20 20 0 12 -37 13
					-44 1 -3 -5 -25 -7 -48 -5 -50 5 -92 -23 -103 -68 -5 -21 -3 -27 15 -33 34
					-11 85 3 110 30 26 28 70 34 70 10 0 -22 37 -18 62 7 l21 21 39 -22 c21 -12
					43 -19 48 -16 19 11 10 34 -19 51 -30 18 -41 39 -41 82 0 15 -6 22 -19 22 -15
					0 -23 -13 -36 -55z m-160 -75 c-3 -5 -12 -10 -18 -10 -7 0 -6 4 3 10 19 12 23
					12 15 0z"/>
			</g>
		</svg>
  )
}

export {Signature}